// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
//  admin/src/pages/Login.jsx  —  Quickry Admin
//  Copy to: C:\quickry\admin\src\pages\Login.jsx
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
import { useState } from "react";
import {
  Mail, Lock, Eye, EyeOff, Loader2,
  ShieldCheck, Zap, AlertCircle,
} from "lucide-react";

const T = {
  primary:     "#f97316",
  primaryDark: "#ea580c",
  primaryLight:"#fff7ed",
  white:       "#ffffff",
  bg:          "#f8fafc",
  text:        "#0f172a",
  textSub:     "#64748b",
  textMuted:   "#94a3b8",
  border:      "#e2e8f0",
  red:         "#ef4444",
  redLight:    "#fef2f2",
  green:       "#16a34a",
};

// ✅ FIX: localhost nahi — api.quickry.in hardcoded
// axios import hata diya — seedha fetch use karo
const API_URL = "https://quickry-ivrv.onrender.com/api";

export default function Login({ onSuccess }) {
  const [email,    setEmail]    = useState("");
  const [password, setPassword] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      setError("Email aur password dono required hain!");
      return;
    }

    setLoading(true);
    setError("");

    try {
      // ✅ FIX: api.quickry.in use karo — kisi bhi device se kaam karega
      const res = await fetch(`${API_URL}/admin/login`, {
        method:  "POST",
        headers: { "Content-Type": "application/json" },
        body:    JSON.stringify({ email, password }),
      });

      const data = await res.json();

      if (!res.ok || !data.success) {
        setError(data.message || "Login failed. Check credentials.");
        return;
      }

      // Token save karo
      localStorage.setItem("adminToken", data.token);
      localStorage.setItem("adminData", JSON.stringify({
        email: data.admin?.email || email,
        role:  data.admin?.role  || "admin",
      }));

      if (onSuccess) onSuccess();

    } catch (err) {
      setError("Server se connect nahi ho pa raha. Internet check karo.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontFamily: "'Plus Jakarta Sans', 'Outfit', sans-serif",
      padding: 20,
      position: "relative",
      overflow: "hidden",
    }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,800;9..144,900&family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        input::placeholder { color: #94a3b8; }
        @keyframes fadeUp { from{opacity:0;transform:translateY(20px)} to{opacity:1;transform:translateY(0)} }
        @keyframes spin { to { transform: rotate(360deg); } }
        .card { animation: fadeUp .5s ease both; }
        .spin { animation: spin 1s linear infinite; }
      `}</style>

      <div style={{ position:"absolute", top:-100, right:-100, width:400, height:400, borderRadius:"50%", background:"radial-gradient(circle, rgba(249,115,22,0.15) 0%, transparent 70%)", pointerEvents:"none" }}/>
      <div style={{ position:"absolute", bottom:-100, left:-100, width:350, height:350, borderRadius:"50%", background:"radial-gradient(circle, rgba(249,115,22,0.1) 0%, transparent 70%)", pointerEvents:"none" }}/>

      <div className="card" style={{ width:"100%", maxWidth:420 }}>

        {/* Logo */}
        <div style={{ textAlign:"center", marginBottom:32 }}>
          <div style={{ display:"inline-flex", alignItems:"center", justifyContent:"center", width:64, height:64, background:`linear-gradient(135deg, ${T.primaryDark}, ${T.primary})`, borderRadius:20, marginBottom:16, boxShadow:"0 8px 32px rgba(249,115,22,0.4)" }}>
            <Zap size={30} color="#fff" strokeWidth={2.5}/>
          </div>
          <div style={{ fontFamily:"'Fraunces',Georgia,serif", fontWeight:900, fontSize:"1.8rem", color:"#fff", letterSpacing:"-1px" }}>
            Quick<span style={{ color:T.primary }}>ry</span>
          </div>
          <div style={{ color:"#94a3b8", fontSize:"0.82rem", marginTop:6, fontWeight:500 }}>
            Admin Panel — Akola
          </div>
        </div>

        {/* Card */}
        <div style={{ background:T.white, borderRadius:24, padding:"32px 28px", boxShadow:"0 24px 64px rgba(0,0,0,0.3)" }}>

          <div style={{ marginBottom:24 }}>
            <div style={{ fontFamily:"'Fraunces',Georgia,serif", fontWeight:900, fontSize:"1.3rem", color:T.text, marginBottom:4 }}>
              Welcome back 👋
            </div>
            <div style={{ fontSize:"0.82rem", color:T.textSub }}>
              Sign in to manage your Quickry platform
            </div>
          </div>

          {error && (
            <div style={{ background:T.redLight, border:"1px solid #fecaca", borderRadius:12, padding:"10px 14px", marginBottom:18, display:"flex", alignItems:"center", gap:8 }}>
              <AlertCircle size={16} color={T.red} style={{ flexShrink:0 }}/>
              <span style={{ fontSize:"0.82rem", color:T.red, fontWeight:600 }}>{error}</span>
            </div>
          )}

          <form onSubmit={handleLogin} style={{ display:"flex", flexDirection:"column", gap:14 }}>

            <div>
              <label style={{ fontSize:"0.72rem", fontWeight:700, color:T.textSub, display:"block", marginBottom:6, textTransform:"uppercase", letterSpacing:"0.5px" }}>
                Email Address
              </label>
              <div style={{ position:"relative", display:"flex", alignItems:"center" }}>
                <Mail size={16} color={T.textMuted} style={{ position:"absolute", left:14, pointerEvents:"none" }}/>
                <input
                  type="email"
                  placeholder="admin@quickry.in"
                  value={email}
                  onChange={e => { setEmail(e.target.value); setError(""); }}
                  style={{ width:"100%", border:`1.5px solid ${T.border}`, borderRadius:12, padding:"11px 14px 11px 42px", fontSize:"0.88rem", color:T.text, outline:"none", fontFamily:"inherit", background:"#f8fafc" }}
                  onFocus={e => e.target.style.borderColor = T.primary}
                  onBlur={e  => e.target.style.borderColor = T.border}
                />
              </div>
            </div>

            <div>
              <label style={{ fontSize:"0.72rem", fontWeight:700, color:T.textSub, display:"block", marginBottom:6, textTransform:"uppercase", letterSpacing:"0.5px" }}>
                Password
              </label>
              <div style={{ position:"relative", display:"flex", alignItems:"center" }}>
                <Lock size={16} color={T.textMuted} style={{ position:"absolute", left:14, pointerEvents:"none" }}/>
                <input
                  type={showPass ? "text" : "password"}
                  placeholder="Enter your password"
                  value={password}
                  onChange={e => { setPassword(e.target.value); setError(""); }}
                  style={{ width:"100%", border:`1.5px solid ${T.border}`, borderRadius:12, padding:"11px 42px 11px 42px", fontSize:"0.88rem", color:T.text, outline:"none", fontFamily:"inherit", background:"#f8fafc" }}
                  onFocus={e => e.target.style.borderColor = T.primary}
                  onBlur={e  => e.target.style.borderColor = T.border}
                />
                <button type="button" onClick={() => setShowPass(s => !s)}
                  style={{ position:"absolute", right:14, background:"none", border:"none", cursor:"pointer", color:T.textMuted, display:"flex", padding:0 }}>
                  {showPass ? <EyeOff size={16}/> : <Eye size={16}/>}
                </button>
              </div>
            </div>

            <button type="submit" disabled={loading}
              style={{ background: loading ? "#fed7aa" : `linear-gradient(135deg, ${T.primaryDark}, ${T.primary})`, border:"none", borderRadius:12, padding:"13px", color:"#fff", fontWeight:800, fontSize:"0.92rem", cursor: loading ? "not-allowed" : "pointer", fontFamily:"inherit", marginTop:4, display:"flex", alignItems:"center", justifyContent:"center", gap:8, boxShadow: loading ? "none" : "0 4px 16px rgba(249,115,22,0.35)" }}>
              {loading
                ? <><Loader2 size={18} className="spin"/> Signing in...</>
                : <><ShieldCheck size={18}/> Sign In to Admin Panel</>
              }
            </button>
          </form>

          <div style={{ marginTop:20, padding:"12px 14px", background:"#f8fafc", borderRadius:12, border:`1px solid ${T.border}` }}>
            <div style={{ fontSize:"0.72rem", color:T.textMuted, fontWeight:600, marginBottom:4 }}>🔐 SECURE ACCESS</div>
            <div style={{ fontSize:"0.75rem", color:T.textSub, lineHeight:1.6 }}>Only authorized admins can access this panel.</div>
          </div>
        </div>

        <div style={{ textAlign:"center", marginTop:16, fontSize:"0.72rem", color:"#475569" }}>
          Quickry Admin v2.0 · Akola, Maharashtra
        </div>
      </div>
    </div>
  );
}